import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { DeliveryType, Order, OrderStatus } from '@api/Orders/Order';
import { differenceInMinutes, format } from 'date-fns';
import { makeStyles } from '@mui/styles';
import { Warning, Payments, Moped, Fastfood, EventAvailable } from '@mui/icons-material';

interface OrderLabelNameProps {
    order: Order;
    isSelected?: boolean;
    onSelectOrder: (order: Order) => void;
}

const useStyles = makeStyles(() => ({
    alarmActive: {
        animation: '$ringing 1s linear infinite'
    },
    '@keyframes ringing': {
        '0%': {
            transform: 'rotate(0deg)'
        },
        '20%': {
            transform: 'rotate(30deg)'
        },
        '30%': {
            transform: 'rotate(-30deg)'
        },
        '40%': {
            transform: 'rotate(30deg)'
        },
        '50%': {
            transform: 'rotate(-30deg)'
        },
        '60%': {
            transform: 'rotate(30deg)'
        },
        '66%': {
            transform: 'rotate(0deg)'
        },
        '100%': {
            transform: 'rotate(0deg)'
        }
    }
}));

const OrderLabelName: React.FunctionComponent<OrderLabelNameProps> = (props) => {
    const { order, isSelected, onSelectOrder } = props;
    const classes = useStyles();

    const isLate = () => {
        const difference = differenceInMinutes(new Date(), order.date.toDate());
        return (
            difference >= 15 &&
            order.status !== OrderStatus.Ready &&
            order.status !== OrderStatus.Route &&
            order.status !== OrderStatus.Completed &&
            order.status !== OrderStatus.Cancelled
        );
    };

    const isWaitingForPayment = () => {
        return order.status === OrderStatus.WaitingForPayment;
    };

    return (
        <Stack
            bgcolor={isSelected ? 'grey.200' : 'transparent'}
            direction="row"
            spacing={2}
            alignItems="center"
            sx={{ cursor: 'pointer' }}
            px={4}
            py={2}
            onClick={() => onSelectOrder(order)}
        >
            <Typography fontWeight={700}>{String(Number(order.shortId.split('-')[1])).padStart(2, '0')}</Typography>
            <Box flex={1}>
                <Typography
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '1',
                        WebkitBoxOrient: 'vertical'
                    }}
                    color={isLate() ? 'red' : 'black'}
                >
                    {`${
                        order.salesChannel
                            ? order.salesChannel?.name
                            : order.tableKiosk
                            ? order.tableKiosk.name
                            : order.deliveryType || 'None'
                    } - ${order.customer?.profile?.name}`}
                </Typography>
            </Box>
            {order.isReservation && (
                <Chip
                    size="small"
                    color="success"
                    icon={<EventAvailable sx={{ fontSize: 16 }} />}
                    label={order.reservationDate ? format(order.reservationDate.toDate(), 'dd/MM HH:mm') : 'Reserva'}
                />
            )}
            {isLate() && <Warning color="warning" className={classes.alarmActive} />}
            {isWaitingForPayment() && <Payments color="primary" className={classes.alarmActive} />}
            {order.deliveryType === DeliveryType.Pickup && <Fastfood color="primary" />}
            {order.deliveryType === DeliveryType.Delivery && <Moped color="primary" />}
        </Stack>
    );
};
export default OrderLabelName;
